var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 4",
    x: 0.5,
    y: 1,
    width: 14,
    height: 14,
    rx: 7,
    stroke: "#587E85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8C11 8.483 10.608 8.875 10.125 8.875H8.375V10.625C8.375 11.108 7.983 11.5 7.5 11.5C7.017 11.5 6.625 11.108 6.625 10.625V8.875H4.875C4.392 8.875 4 8.483 4 8C4 7.517 4.392 7.125 4.875 7.125H6.625V5.375C6.625 4.892 7.017 4.5 7.5 4.5C7.983 4.5 8.375 4.892 8.375 5.375V7.125H10.125C10.608 7.125 11 7.517 11 8",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8C11 8.483 10.608 8.875 10.125 8.875H8.375V10.625C8.375 11.108 7.983 11.5 7.5 11.5C7.017 11.5 6.625 11.108 6.625 10.625V8.875H4.875C4.392 8.875 4 8.483 4 8C4 7.517 4.392 7.125 4.875 7.125H6.625V5.375C6.625 4.892 7.017 4.5 7.5 4.5C7.983 4.5 8.375 4.892 8.375 5.375V7.125H10.125C10.608 7.125 11 7.517 11 8",
    stroke: "white",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6);
export default __webpack_public_path__ + "static/media/Group 6.451ecfcba7acb8154a8b4858266c01ed.svg";
export { ForwardRef as ReactComponent };